/**
 * Dig mode (Phase 8b): one Claude session on a full page, chat on the left, live work on
 * the right, with every session of the workspace a click away. Admins only.
 */
import { useEffect } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router";
import { EMPTY_EVENTS, loadEvents, loadSessions, openWorkFile, sendWork, setViewMode, useWork } from "../lib/work";
import { useStore } from "../lib/store";
import { WorkView } from "../workview";

export function WorkPage() {
  const { sessionId = "" } = useParams();
  const navigate = useNavigate();
  const boot = useStore((s) => s.boot)!;
  const sessions = useWork((w) => w.sessions);
  const events = useWork((w) => w.events[sessionId] ?? EMPTY_EVENTS);
  const auth = useWork((w) => w.auth);
  const online = useWork((w) => w.online);
  const reason = useWork((w) => w.reason);
  const mode = useWork((w) => w.mode);
  const session = sessions[sessionId];
  useEffect(() => {
    void loadSessions();
  }, []);
  useEffect(() => {
    if (sessionId) void loadEvents(sessionId);
  }, [sessionId]);
  if (boot.workspace.role !== "admin") return <Navigate to="/" replace />;
  const list = Object.values(sessions)
    .filter((s) => s.kind !== "quick" || s.id === sessionId)
    .sort((a, b) => (b.lastTurnAt ?? "").localeCompare(a.lastTurnAt ?? ""));
  return (
    <main className="work-page">
      <div className="work-bar">
        <p className="crumbs">
          <Link to="/settings">Settings</Link>
        </p>
        <h1>Claude at work</h1>
        <select value={sessionId} onChange={(e) => navigate(`/work/${e.target.value}`)} aria-label="Session">
          {!session && <option value={sessionId}>Loading</option>}
          {list.map((s) => (
            <option key={s.id} value={s.id}>
              {s.title}
              {s.openPrompts ? `, ${s.openPrompts} waiting for you` : s.busy ? ", working" : ""}
            </option>
          ))}
        </select>
        <span className={online ? "work-online" : "work-offline"}>{online ? `Online on ${auth?.subscriptionType ?? "the plan"}, no API key` : `Offline: ${reason || "not connected"}`}</span>
      </div>
      <div className="work-frame">
        <WorkView
          layout="full"
          title={session?.title ?? "Claude"}
          events={events}
          live={session?.live}
          canDrive={Boolean(boot.me.isOwner)}
          send={(cmd) => sendWork(sessionId, cmd)}
          openFile={(path) => openWorkFile(sessionId, path)}
          viewMode={mode === "dig" ? "dig" : mode}
          onViewMode={(m) => setViewMode(m)}
        />
      </div>
    </main>
  );
}
